import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { pageColors } from "../../mock";
import { useCart } from "../../context/CartContext";
import { ArrowLeft, ShoppingBag, Check } from "lucide-react";

const SIZES = ["S", "M", "L", "XL"];
const PRICE = 70;

const KoreVelum = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [size, setSize] = useState("M");
  const [added, setAdded] = useState(false);

  useEffect(() => { document.title = "TMM|KORE VELUM"; }, []);

  const preorder = () => {
    addItem({
      id: `kv-tee-${size.toLowerCase()}`,
      name: `Kore Velum Tee — size ${size}`,
      price: PRICE,
      image: "/img/kvfront.png",
      description: "Kore Velum distressed gothic tee — pre-order.",
      tag: "kv",
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="brand-page">
        <button className="feed-back" onClick={() => navigate("/fashion")} data-testid="kv-back">
          <ArrowLeft size={16} /> Back to Fashion
        </button>

        <header className="brand-hero-center" data-testid="kv-hero">
          <img src="/img/kv.png" alt="Kore Velum" className="brand-hero-mark kv" />
        </header>

        <section className="brand-preorder-preview" data-testid="kv-preview">
          <div className="brand-preorder-tile">
            <img src="/img/kvfront.png" alt="Kore Velum tee — front" />
          </div>
          <div className="brand-preorder-tile">
            <img src="/img/kvback.png" alt="Kore Velum tee — back" />
          </div>
        </section>

        <section className="brand-preorder-panel" data-testid="kv-preorder-panel">
          <div className="brand-preorder-name">Kore Velum Tee</div>
          <div className="brand-preorder-price">${PRICE}</div>

          <div className="brand-size-block">
            <div className="brand-size-label">Size</div>
            <div className="brand-size-row" role="radiogroup" aria-label="Select size">
              {SIZES.map((s) => (
                <button
                  key={s}
                  type="button"
                  role="radio"
                  aria-checked={size === s}
                  className={`brand-size-chip${size === s ? " active" : ""}`}
                  onClick={() => setSize(s)}
                  data-testid={`kv-size-${s}`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <button
            type="button"
            className="btn-solid btn-huge"
            onClick={preorder}
            data-testid="kv-preorder-btn"
          >
            {added ? (
              <>
                <Check size={18} /> Added — size {size}
              </>
            ) : (
              <>
                <ShoppingBag size={18} /> Pre-order — size {size}
              </>
            )}
          </button>
          <p className="brand-preorder-note">
            Distressed 100% cotton, oversized fit. First run ships in 4-6
            weeks. Cancel anytime before production begins.
          </p>
        </section>
      </div>
    </>
  );
};

export default KoreVelum;
